"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _StackingLayout = _interopRequireDefault(require("../Layouts/StackingLayout"));

var _MultiSelectedItemTag = _interopRequireDefault(require("./MultiSelectedItemTag"));

var _TextLabel = _interopRequireDefault(require("../Typography/TextLabel"));

var _TextInput2 = _interopRequireDefault(require("../Input/TextInput"));

var _InputWidthProvider = _interopRequireDefault(require("../Utility/InputWidthProvider"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TextInput = (0, _InputWidthProvider.default)(_TextInput2.default);
/**
 * This is a private internal component for Select.  It provides a
 * wrapper around MultiSelectedItemTag items. Note: this can take on any
 * valid input dom properties.
 */

var MultiSelectInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MultiSelectInput, _React$Component);

  function MultiSelectInput(props) {
    var _this;

    _classCallCheck(this, MultiSelectInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiSelectInput).call(this, props));

    _this.handleMouseDown = function (event) {
      _this.setState({
        isFocus: true
      });

      var onMouseDown = _this.props.onMouseDown;

      if (onMouseDown) {
        onMouseDown(event);
      }
    };

    _this.handleOnBlur = function (event) {
      _this.setState({
        isFocus: false
      });

      var onBlur = _this.props.onBlur;

      if (onBlur) {
        onBlur(event);
      }
    };

    _this.handleOnFocus = function (event) {
      _this.setState({
        isFocus: true
      });

      var onFocus = _this.props.onFocus;

      if (onFocus) {
        onFocus(event);
      }
    };

    _this.state = {
      isFocus: false
    };
    _this.inputRef = _react.default.createRef();
    return _this;
  }

  _createClass(MultiSelectInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setInputFocus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setInputFocus();
    }
  }, {
    key: "setInputFocus",
    value: function setInputFocus() {
      var focus = this.props.focus;

      if (focus) {
        // Note we don't need to setState isFocus here.
        // This focus() call will trigger handleOnFocus().
        this.inputRef.current.focus();
      }
    }
    /**
     * Handler when mouse is press to set focus.
     * @param {ReactEvent} event - React event.
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled,
          wrapperProps = _this$props.wrapperProps,
          focus = _this$props.focus,
          inputProps = _objectWithoutProperties(_this$props, ["className", "children", "placeholder", "disabled", "wrapperProps", "focus"]);

      var styleProps = {
        'data-input-focus': this.state.isFocus,
        'data-disabled': disabled
      };
      var inputNode;

      if (!disabled) {
        inputNode = _react.default.createElement(TextInput, _extends({
          type: "nested",
          inputRef: this.inputRef
        }, inputProps, {
          disabled: disabled,
          placeholder: !_react.default.Children.count(children) ? placeholder : null,
          onBlur: this.handleOnBlur,
          onFocus: this.handleOnFocus
        }));
      } else if (!_react.default.Children.count(children)) {
        // If it is disabled and there are not any selected tags
        inputNode = _react.default.createElement(_TextLabel.default, {
          className: "placeholder",
          type: _TextLabel.default.TEXT_LABEL_TYPE.SECONDARY
        }, placeholder);
      }

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement(_StackingLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(clsPrfx, " ").concat(clsPrfx, "-multi-select-input")),
        itemSpacing: "10px",
        onMouseDown: this.handleMouseDown
      }, styleProps, wrapperProps), _react.default.createElement(_FlexLayout.default, {
        className: "multi-select-input-wrapper",
        flexWrap: "wrap",
        itemSpacing: "5px",
        alignItems: "center"
      }, children, inputNode));
    }
  }]);

  return MultiSelectInput;
}(_react.default.Component);

exports.default = MultiSelectInput;
MultiSelectInput.defaultProps = {
  placeholder: 'Please select',
  disabled: false,
  focus: false,
  wrapperProps: {}
};
MultiSelectInput.propTypes = {
  className: _propTypes.default.string,

  /**
   * placeholder string to display when no items are listed.
   */
  placeholder: _propTypes.default.string,

  /**
   * Note: if this is set it will override the internal isFocus state.
   * It is up to the user to listen to onBlur/onFocus and set this appropriately.
   */
  focus: _propTypes.default.bool,

  /**
   * Disable the component.
   */
  disabled: _propTypes.default.bool,

  /**
   * Array of MultiSelectedItemTag
   */
  children: _propTypes.default.oneOfType([_propTypes.default.instanceOf(_MultiSelectedItemTag.default), // It should be this
  // PropTypes.instanceOf(MultiSelectedItemTag)
  // instead of PropTypes.node but I think there is a
  // bug in PropTypes.
  _propTypes.default.arrayOf(_propTypes.default.node)]),

  /**
   * Additional dom attributes for the top level wrapping dom element.
   */
  wrapperProps: _propTypes.default.object
};